module.exports = __webpack_public_path__ + "static/media/ServiceNow_Step4_end_card.1bbc499c.jpg";